import { render, staticRenderFns } from "./OfferPerspectiveRulesTableWrapper.vue?vue&type=template&id=95f633a2&scoped=true"
import script from "./OfferPerspectiveRulesTableWrapper.vue?vue&type=script&lang=js"
export * from "./OfferPerspectiveRulesTableWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f633a2",
  null
  
)

export default component.exports